<template>
  <div id="checkoutProgress" class="checkout-steps mt-2 mb-4 flex justify-center border-b border-gray-10">
    <ol class="checkout-steps__list flex items-end">
      <template v-for="(step, index) in registrationSteps">
        <li :key="index" class="checkout-steps__item" :class="step.progressBarId === currentStep ? 'is-active' : ''">
          <span :id="`checkout-progress-bar-${index + 1}`" :class="linkClasses">{{ step.text }}</span>
        </li>
      </template>
    </ol>
  </div>
</template>
<script>
export default {
  props: {
    currentStep: {
      type: String,
      default: '',
    },
    baseProperties: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      linkClasses:
        'checkout-steps__link relative block p-2 text-sm md:text-base font-medium leading-normal text-gray-80 text-center',
    };
  },

  computed: {
    registrationSteps() {
      return [
        {progressBarId: 'findbike', text: this.bp('findBike')},
        {progressBarId: 'verify', text: this.bp('verify')},
        {progressBarId: 'register', text: this.bp('register')},
      ];
    },
  },
};
</script>
